import { Typography } from '@/ui-kit';
import { MessageChat } from '../message-chat';
import styles from './messages-list.module.scss';
import { Chat } from '@/types/chat';
import { SkeletonMessagesList } from './skeleton-messages-list';
import { EmptyMessages } from '../empty-messages/';
import { EmptyCouples } from '../empty-couples';
import InfiniteScroll from 'react-infinite-scroll-component';
import { PulseLoader } from 'react-spinners';
import { useEffect, useState } from 'react';
import { PaginationDto } from '@/types/message';
import { NotModeratedChats } from '../not-moderated-chats';
import { ModerationPendingChats } from '../moderation-pending-chats';
import { HalfDone } from '../half-done';

interface Props {
    chatList?: Chat[] | null;
    isLoading: boolean;
    isEmptyMessage?: boolean;
    isNotModerated?: boolean;
    isModerationPending?: boolean;
    isFillYourDataFinished?: boolean;
    pagination: PaginationDto | null,
    loadMoreChats?: () => void;
}

export const MessagesList: React.FC<Props> = ({
    chatList,
    isLoading,
    isEmptyMessage,
    isNotModerated,
    isModerationPending,
    isFillYourDataFinished,
    pagination,
    loadMoreChats,
}) => {
    const [hasMoreChats, setHasMoreChats] = useState(false);
    useEffect(() => {
        setHasMoreChats(pagination?.next !== null);
    }, [pagination]);

    return (
        <div className={styles.container}>
            <div className={styles.label}>
                <Typography
                    typeColor="gray"
                    uppercase
                    variant="span">
                    Чаты
                </Typography>
            </div>
            {
                !isNotModerated &&
                !isFillYourDataFinished &&
                <div className={styles.messagesList}>
                    {
                        !isLoading && chatList && chatList?.length === 0 ? (
                            <EmptyMessages
                                title="У вас есть новые пары"
                                text="Начните общение прямо сейчас" />
                        ) : !isLoading && chatList && chatList.length > 0 ? (
                            <InfiniteScroll
                                dataLength={chatList?.length}
                                next={() => {
                                    loadMoreChats?.()
                                    if (!pagination)
                                        setHasMoreChats(false)
                                }}
                                hasMore={hasMoreChats}
                                loader={
                                    <div className={styles.loader}>
                                        <PulseLoader
                                            size={12}
                                            color="#f26a1c" />
                                    </div>
                                }>
                                {
                                    chatList?.map((chat) => (
                                        <MessageChat
                                            chat={chat}
                                            key={chat.chat_id} />
                                    ))
                                }
                            </InfiniteScroll>
                        ) : (
                            <SkeletonMessagesList />
                        )
                    }
                </div>
            }
            {isEmptyMessage && <EmptyCouples />}
            {
                isNotModerated && (
                    isModerationPending ?
                        <ModerationPendingChats />
                    :
                        <NotModeratedChats />
                )
            }
            {
                isFillYourDataFinished && (
                    <HalfDone variant={'secondary'} />
                )
            }
        </div>
    );
};
